import { Dispatch, SetStateAction } from "react"
import { Grid } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { CreateOrderDialogFlow, CreateOrderDialogType, SelectedMainUserState } from "../../../createOrderTypes"
import { MeetingServiceConfig, DynamicConfigKey } from "../../form/formTypes"
import { DeliveryTimeSelector } from "../delivery/DeliveryTimeSelector"
import { UserType } from "../../../../../../modules/login/loginTypes"
import { ActionButtons } from "./ActionButtons"
import { ShopFiltersTypes } from "../ShopList"

const useStyles = makeStyles()((theme) => ({
    container: {
        padding: "1.25rem 1rem 1.5rem",
        background: theme.palette.common.white,
    },
}))

type ShopListHeaderProps = Readonly<{
    filters: ShopFiltersTypes
    setFilters: Dispatch<SetStateAction<ShopFiltersTypes>>
    meetingServiceConfiguration?: MeetingServiceConfig
    handleCloseMainDialog: () => void
    flowConfig?: CreateOrderDialogFlow
    dialogType: CreateOrderDialogType
    user: SelectedMainUserState
}>

export function ShopListHeader({
    filters,
    setFilters,
    meetingServiceConfiguration,
    handleCloseMainDialog,
    flowConfig,
    dialogType,
    user,
}: ShopListHeaderProps) {
    const { classes } = useStyles()
    const isRefundOrder = dialogType === CreateOrderDialogType.CREDIT_NOTE

    const findProductWish = meetingServiceConfiguration?.sections
        .flatMap(({ groups }) => groups.flatMap(({ fields }) => fields))
        .find((field) => field.key === DynamicConfigKey.PRODUCT_WISH)?.active

    return (
        <Grid
            container
            alignItems="center"
            gap=".75rem"
            flexWrap="nowrap"
            justifyContent="space-between"
            className={classes.container}
        >
            {meetingServiceConfiguration && (
                <DeliveryTimeSelector
                    meetingServiceConfiguration={meetingServiceConfiguration}
                    handleCloseMainDialog={handleCloseMainDialog}
                    flowConfig={flowConfig}
                    disabled={dialogType !== CreateOrderDialogType.ORDER}
                    allowOutsideBusinessHours={user.userType === UserType.MERCHANT}
                />
            )}
            {!isRefundOrder && (
                <ActionButtons
                    filters={filters}
                    setFilters={setFilters}
                    isProductWish={!!findProductWish}
                    isRefundOrder={isRefundOrder}
                />
            )}
        </Grid>
    )
}
